import React from "react";
import Base from '../core/Base'
import HeaderTitle from '../components/HeaderTitle'
const About = () => {
  return (
   <Base>
       <HeaderTitle title='About Us'/>
       <div id="search-area">
           <button type="button" className="close">×</button>
           <form>
               <input type="search" value="" placeholder="Search Kewword(s)"/>
                   <button type="submit" className="btn btn-primary">Search</button>
           </form>
       </div>
       <section className="about-area ptb-100">
           <div className="container">
               <div className="row mb-3">
                   <div className="col-lg-6 col-md-12">
                       <div className="about-text">
                           <h3>Welcome To <span>SarkariZone</span></h3>

                           <h5>SarkariZone (Study Point & Library) establish in 2018. We always work together to provides all the facilities to our valuable students.</h5>

                           <p>We maintain proper discipline in our library. If you are looking for best library in Agra in less price, then join to SarkariZone Library.</p>

                           <p> A library is a curated collection of sources of information and similar resources, selected by experts and made accessible to a defined community for reference or borrowing. It provides physical or digital access to material, and may be a physical location or a virtual space or both.</p>

                           <p className="mb-0">We committed to serve you with the best reading materials, the SarkariZone would like to draw your attention on our services to know more about us.</p>
                       </div>
                   </div>

                   <div className="col-lg-6 col-md-12 mt-5">
                       <div className="about-slider">
                           <div className="item">
                               <img src='https://trello-attachments.s3.amazonaws.com/5f8186eddebc0f7224a214d6/550x400/b17a4d159ee491b8b5472e592bf47365/about_us_image.jpg'
                                    className='img-fluid' alt='Sarkarizone-library-study-point'/>
                           </div>
                       </div>
                   </div>

                   <div className="col-lg-4 col-md-6 mt-5">
                       <div className="card newCard">
                           <div className='img-overlay text-center'>CCTV SECURITY</div>
                           <img src={require('../assets/img/CCTV.jpg')}
                                className="card-img-top" alt="cctv-security Sarkarizone-libraryin-agra"/>
                           <div className="card-body">
                               <p className="card-text">All your materials like bags, books, helmets, and any other
                                   important thing is totally secured and recorded in our CCTV cameras</p>
                           </div>
                       </div>
                   </div>

                   <div className="col-lg-4 col-md-6 mt-5">
                       <div className="card newCard newCardtext-white bg-light mb-3">
                           <div className='img-overlay text-center'>BEST INFRASTRUCTURE</div>
                           <img src={require('../assets/img/best_infrastructure.jpg')}
                                className="card-img-top" alt="Sarkarizone-best_infrastructure"/>
                           <div className="card-body">
                               <p className="card-text">Here you get the best furniture, comfortable chairs for
                                   your comfort, secured electric system.
                               </p>
                           </div>
                       </div>

                   </div>

                   <div className="col-lg-4 col-md-6 mt-5 offset-md-3 offset-lg-0">
                       <div className="card newCard newCardtext-white bg-light mb-3">
                           <div className='img-overlay text-center'>EYES PROTECTING</div>
                           <img src={require('../assets/img/eyes_protection.jpg')}
                                className="card-img-top" alt="Sarkarizone-eyes_protection"/>
                           <div className="card-body">
                               <p className="card-text">We used good quality of lightning in our library, which
                                   will protect your eyes from the harmful rays of the electrical appliances.
                               </p>
                           </div>
                       </div>
                   </div>

                   <div className="col-lg-6 col-md-6">
                       <div className="about-content">
                           <h3>Who we are?</h3>

                           <p>Sarkari Zone library is the no.1 library in agra.we were established in the year 2018. We are IT professionals.
                               Libraries are essential in a process of giving citizens access to knowledge.
                               In digital times they are needed more than ever before.</p>

                           <p className="mb-0">In times of the internet, everyone can visit a library without leaving home.
                               It's just a matter of opening a library website, and you can not only borrow an ebook but also ask the librarian an online question.
                               Most importantly, however, libraries are the places where you can expect smart and clear answers to even the most difficult questions.</p>
                       </div>
                   </div>

                   <div className="col-lg-6 col-md-6">
                       <div className="about-content">
                           <h3>Our mission</h3>

                           <p>The very most mission of our is that we can go more far and far in learning and creating more ideas for students brighter future. we support our students in every field.
                               The Library promote intellectual growth and creativity by developing collections, facilitating access to information resources, teaching the effective use of information resources and critical evaluation skills and offering research assistance. </p>

                           <p className="mb-0">We develop, organize, provide access to and preserve materials to meet the needs of present and future generations of students.
                               We explore and implement innovative technologies and services to deliver information. </p>
                       </div>
                   </div>
               </div>
           </div>
       </section>
   </Base>
  );
};

export default About;
